import React, { Component } from 'react';
import cx from 'classnames';

import Champion from './Champion';
import Team from './Team';

import Loading from './Loading';

const io = require("socket.io-client");

import {PHASES, ROUND_DURATION, getTeamTurn, getPhase, getSelectedChampion} from './phases';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: '',
      championIndex: this.props.champions.reduce((d, c) => {
        d[c.id] = c;
        return d;
      }, {})
    };
  }
  componentDidMount() {
      const socket = io(`${this.props.host}`);
      let timeDiff = 0;
      let emittedRoundTimeouts = 0;
      this.socket = socket;

      const getRoundDuration = s => {
        return Math.max(0, Math.round(((s.roundStart + ROUND_DURATION) + timeDiff - Date.now()) / 1000));
      };

      socket.on('connect', () => {
        const interval = setInterval(() => {
          this.setState(s => {
            if (!s.teams.every(t => t.ready)) {
              return {};
            }

            if (s.phase >= PHASES.length) {
              socket.disconnect();
            }

            const roundDuration = getRoundDuration(s);
            if (Date.now() - emittedRoundTimeouts > 5000 && roundDuration <= 0 && this.props.auth) {
              emittedRoundTimeouts = Date.now();
              socket.emit('roundTimeout', this.props.draft);
            }
            return {roundDuration};
          });
        }, 500);

        socket.on('disconnect', () => clearInterval(interval));
        socket.emit('draft', {draft: this.props.draft, auth: this.props.auth});
      });
      socket.on('state', state => {
        state.teams.forEach(t => {
          t.picks = t.picks.map(c => c !== null ? this.state.championIndex[c] : null);
          t.bans = t.bans.map(c => c !== null ? this.state.championIndex[c] : null);
        });
        const serverTime = new Date();
        serverTime.setTime(state.currentTime);
        timeDiff = Date.now() - serverTime;
        state.roundDuration = getRoundDuration(state);
        this.setState(state)
      });
  }

  markChampion(c) {
    if (this.state.phase >= PHASES.length) {
      return;
    }

    this.socket.emit('markChampion', {draft: this.props.draft, auth: this.props.auth, champion: c.id})
  }

  confirmChampion() {
    if (this.state.phase >= PHASES.length) {
      return;
    }
    this.socket.emit('confirmChampion', {draft: this.props.draft, auth: this.props.auth});
    this.setState({search: ''});
  }

  readyCheck() {
    if (typeof(this.state.authTeam) !== 'number' || this.state.teams[this.state.authTeam].ready) {
      return;
    }

    this.socket.emit('readyCheck', {draft: this.props.draft, auth: this.props.auth});
  }

  _selectedChampions() {
    return this.state.teams.reduce((i, t) => i.concat(t.picks.concat(t.bans)), []).map(c => c ? c.id : null);
  }

  render() {
    const champions = this.props.champions.filter(c => this.state.search.length === 0 || c.name.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1);
    const teamsReady = this.state.teams && this.state.teams.every(t => t.ready);
    return (
      <div>
        <div className="background"></div>
        <div className="background second"></div>
        <div className={cx(['App', getPhase(this.state.phase)])}>
          {this.state.teams ? <div>
            {this.state.teams.map((team, i) => <Team key={i} {...team} ready={teamsReady} turn={i === getTeamTurn(this.state.phase)} phase={getPhase(this.state.phase)} round={this.state.phase} timer={this.state.roundDuration} />)}
          </div> : <Loading />}
          {typeof(this.state.authTeam) === 'number' ? teamsReady ? <div className="picking">
            <div className="selection">
              <input type="text" placeholder="SEARCH" value={this.state.search} onChange={e => this.setState({search: e.target.value})} />
              {getSelectedChampion(this.state.phase, this.state.teams) && getTeamTurn(this.state.phase) === this.state.authTeam ? <button onClick={e => this.confirmChampion()} className="confirm">Select</button> : null}
            </div>
            <div>
              {champions.map(c => {
                return (
                  <Champion {...c} key={c.id} version={this.props.version} selected={this._selectedChampions().indexOf(c.id) !== -1} onClick={() => this.markChampion(c)} />
                );
              })}
            </div>
          </div> : this.state.teams[this.state.authTeam].ready ? 'Waiting for other team' : <button className="confirm readyCheck" onClick={() => this.readyCheck()}>Ready check</button> : null}
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/Draft.js